import LoadingProgressBar from "components/LoadingProgressBar";

import { useLayoutStore } from "@type/store";

interface LayoutDataWrapperProps {
  children: React.ReactNode;
}

const LayoutDataWrapper = ({ children }: LayoutDataWrapperProps) => {
  const showProgress = useLayoutStore((state) => state.showProgress);

  return (
    <>
      <LoadingProgressBar loading={showProgress} />
      {children}
    </>
  );
};

export default LayoutDataWrapper;
